export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "项目信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "招标项目：",
            type: "slot",
            slotName: "prjName",
            required: true,
            width: "100%;",
            rule: {
              required: true,
              message: "该输入项不能为空！",
              trigger: "blur"
            },
          },
          {
            label: "标段：",
            type: "slot",
            slotName: "section",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空！",
              trigger: "blur"
            },
          },
          {
            label: "标段（包）编号：",
            type: "slot",
            slotName: "bidSectionCode",
          },
          {
            label: "行政监督部门：",
            type: "slot",
            slotName: "regulators"
          },
        ]
      },
      {
        title: "终止操作",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "终止节点：",
            value: "terminationNode",
            type: "select",
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空！",
              trigger: "blur"
            },
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201702211537230003"
            },
          },
          {
            label: "终止类型：",
            value: "terminationType",
            type: "select",
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空！",
              trigger: "blur"
            },
            optionData: [
              {
                name: "终止",
                value: "0"
              },
              {
                name: "流标",
                value: "3"
              },
              {
                name: "废标",
                value: "4"
              }
            ],
          },
          {
            label: "终止原因：",
            value: "terminationReason",
            type: "textarea",
            disabled: false,
            required: true,
            width: "100%;",
            rule: {
              required: true,
              message: "该输入项不能为空！",
              trigger: "blur"
            },
          }
        ]
      },
      {
        title: "其他",
        name: "5",
        icon: "",
        formConfigList: [
          // {
          //   label: "核验记录：",
          //   type: "slot",
          //   slotName: "stateName",
          // },
          {
            label: "招标人意见：",
            type: "slot",
            slotName: "tenderOpinion",
            width: "100%;"
          },
        ]
      },
    ];
  }
}
